import EventBus from '~/EventBus'

// Generous: the user has to notice the modal and solve the challenge.
const CHALLENGE_TIMEOUT_MS = 5 * 60 * 1000

export function isCloudflareChallenge(response) {
  return response?.headers?.['cf-mitigated'] === 'challenge'
}

async function waitForChallengeToPass() {
  return new Promise(resolve => {
    function handleMessage(event) {
      // The gate iframe is same-origin (see gate-passed.blade.php).
      if (event.origin !== window.location.origin) return

      if (event.data?.type === 'gate-passed') {
        window.removeEventListener('message', handleMessage)
        clearTimeout(timeoutId)
        resolve(true)
      }
    }

    const timeoutId = setTimeout(() => {
      window.removeEventListener('message', handleMessage)
      resolve(false)
    }, CHALLENGE_TIMEOUT_MS)

    window.addEventListener('message', handleMessage)
  })
}

export async function handleCloudflareChallenge(config) {
  EventBus.$emit('show-cloudflare-challenge')

  const passed = await waitForChallengeToPass()

  EventBus.$emit('close-cloudflare-challenge')

  if (!passed) throw new Error('Cloudflare challenge was not passed')

  return config
}
